import axios, { AxiosInstance } from 'axios';

import { getSession, store } from 'app/state';

export interface IRequest {
  // url?: string;
  baseURL?: string;
  // method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  headers?: Record<string, any>;
  params?: Record<string, any>;
  // data?: any;
}

export interface IWebClient {
  baseURL?: string;
  authenticate?: boolean;
}

export class WebClient {
  protected readonly client: AxiosInstance;

  constructor({ baseURL, authenticate }: IWebClient) {
    this.client = axios.create({ baseURL: baseURL });

    if (authenticate) this.client.interceptors.request.use((request) => {
      const header = 'Authorization';
      if (!request.headers.has(header)) {
        const { accessToken } = (getSession(store.getState()) ?? {});
        if (accessToken) request.headers.set(header, `Bearer ${accessToken}`);
      }

      return request;
    });
    // this.client.interceptors.request.use(request => { console.log('[XHR]', request); return request; });
    // this.client.interceptors.response.use((response) => { console.log('[XHR]', response); return response; });
  }

  public async get<T>(url: string, config?: IRequest): Promise<T> { return this.client.get<T>(url, config).then(response => response.data); }
  public async post<T>(url: string, data?: any, config?: IRequest): Promise<T> { return this.client.post(url, data, config).then(response => response.data); }
  public async put<T>(url: string, data?: any, config?: IRequest): Promise<T> { return this.client.put(url, data, config).then(response => response.data); }
  public async patch<T>(url: string, data?: any, config?: IRequest): Promise<T> { return this.client.patch(url, data, config).then(response => response.data); }
  public async delete<T>(url: string, config?: IRequest): Promise<T> { return this.client.delete(url, config).then(response => response.data); }
}
